export enum ConnectMessageEvent {
  CREATED = 'TL_CONNECT_MESSAGE_CREATED',
}
